import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../Translations/en';
import pl from '../Translations/pl';
import de from '../Translations/de';
import { getInitLanguage } from '../__core/Utils/Language';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    pl: {
      translation: pl,
    },
    de: {
      translation: de,
    },
  },
  lng: getInitLanguage(),
  keySeparator: false,

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
